<template>
    <v-navigation-drawer width="80%" class="navigation-drawer" :value="value" @input="$emit('toggledrawer',$event)" app >
      <!-- <i class="closeIcon" @click="$emit('toggledrawer',false)"></i> -->
      <v-list>
        <div class="wi-100 text-center">
            <v-list-item-avatar size="100" class="ma-0">
                <v-img src="/images/account.png"></v-img>
            </v-list-item-avatar>
        </div>
        <v-list-item-title class="wi-100 text-center mt-2 mb-10 white--text">Jean Christophe</v-list-item-title>
        <v-list-item @click="$emit('hidedrawer')"  to="/interventions">
            <v-list-item-action>
                <navigation-icon-svg type="interventions" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Interventions</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('hidedrawer')"  to="/enquetes">
            <v-list-item-action>
                <navigation-icon-svg type="enquetes" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Enquêtes</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('hidedrawer')"  to="/locataires">
            <v-list-item-action>
                <navigation-icon-svg type="locataires" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Locataires</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('hidedrawer')"  to="/gestion-points/loterie">
            <v-list-item-action>
                <navigation-icon-svg type="gestion-points" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Gestion de points</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('hidedrawer')"  to="/comptes">
            <v-list-item-action>
                <navigation-icon-svg type="comptes" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Comptes</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('hidedrawer')"  to="/action-collaborative">
            <v-list-item-action>
                <navigation-icon-svg type="action-collaborative" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Actions collaboratives</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('hidedrawer')"  to="/annuaire">
            <v-list-item-action>
                <navigation-icon-svg type="annuaire" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Annuaire</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('hidedrawer')"  to="/annonces">
            <v-list-item-action>
                <navigation-icon-svg type="annonces" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Annonces</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('hidedrawer')"  to="/baux">
            <v-list-item-action>
                <navigation-icon-svg type="baux" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Baux</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('hidedrawer')"  to="/operations">
            <v-list-item-action>
                <navigation-icon-svg type="operations" class="mx-auto section-icon"></navigation-icon-svg>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title class="white--text">Opérations</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      </v-list>
      <div v-if="this.$store.getters.isAuthenticated" class="wi-100 d-flex justify-center">
        <j-logout></j-logout>
      </div>
    </v-navigation-drawer>
</template>
<script>
import navigationIconSvg from './NavigationIconSvg.vue'
export default {
    name: 'drawer',
    props: ['value'],
    components: { navigationIconSvg },
    methods: {
    }
}
</script>
<style lang="scss">
  .navigation-drawer{
    padding-top: 2.3rem;
    background: linear-gradient(to bottom, $primary, $grey);
    @include closeIcon(white,2rem,0.1rem,1rem,0.8rem);

    .v-avatar.v-list-item__avatar{
        height: auto !important;
        width: auto !important;
        min-width: auto !important;
    }
    .v-list-item{
        border: white solid 1px;
        border-left: none;
        border-right: none;
        svg{
            height: 1.5rem;
            width: 1.5rem;
            .section-icon-color{
                fill: white;
            }
        }
        +{
            .v-list-item{
                border-top: none;
            }
        }
    }
  }
</style>